export const MANAGER_ROOT = 'manager/';
export const EMPLOYER_MANAGER_ROOT = '/employer';
export const STATISTICS_MANAGER_ROOT = '/statistics';

// Actions types
export const GET_FORM101_OFFICES_LIST = 'getForm101OfficesList';
export const GET_FORM101_UNITS_LIST = 'getForm101UnitsList';
export const FORMS_SEARCH = 'formsSearch';
export const GET_ID_NUMBER_FIELDS = 'getIdNumberFields';
export const GET_STATISTICS = 'getStatistics';
export const GET_STATISTICS_OFFICES = 'getStatisticsOffices';
export const APPROVE_FORM = 'approveForm';
export const REJECT_FORM = 'rejectForm';
export const GET_FORM_101_REJECT_REASON = 'getForm101RejectReason';
export const GET_FORM_STATUS_HISTORY_LIST = 'getFormStatusHistoryList';
export const GET_FORM_101_CHANGES = 'getForm101Changes';
export const SAVE_FORM_101_CHANGES_NOTES = 'saveForm101ChangesNotes';
export const SET_FORM101_SECTION_NOTES = 'setForm101SectionNotes';
export const GET_FORM_DATA = 'getFormData';
export const MANAGER_GET_FORM_101_AS_PDF = 'getForm101AsPdf';
export const MANAGER_GENERATE_FORM_101_AS_PDF = 'generateForm101AsPdf';
export const MANAGER_GET_MANUAL_FORM_101_AS_PDF = 'getManualFormContent';
export const GENERATE_EMPTY_FORM_101_AS_PDF = 'generateEmptyForm101AsPdf';
export const GET_FORM_101_STATUSES_LIST = 'getForm101StatusesList';
export const RESET_PASSWORD = 'resetPassword';
export const DELETE_FORM = 'deleteForm';
export const DELETE_MANUAL_FORM = 'deleteManualForm';
export const GET_MANUAL_FORM_CONTENT = 'getManualFormContent';
export const UPLOAD_MANUAL_FORM = 'uploadManualForm';
export const GENERATE_FORMS_SEARCH_REPORT = 'generateFormsSearchReport';
export const GENERATE_FORM_CHANGES_REPORT = 'generateFormChangesReport';
export const GENERATE_DETAILED_FORMS_REPORT = 'generateDetailedFormsReport';
export const GET_EMPLOYEE_EMAIL = 'getEmployeeEmail';
export const APPROVE_ALL_FORMS = 'approveAllForms';
export const APPROVE_SELECTED_FORMS = 'approveSelectedForms';
export const GET_CUBES_INFO = 'getCubesInfo';
export const GET_CUBE_DETAILS = 'getCubeDetails';
export const UPDATE_IPT = 'updateIpt';
export const MARK_AS_IGNORE = 'markAsIgnore';
export const UNDO_MARK_AS_IGNORE = 'undoMarkAsIgnore';
export const CREATE_MASKIT_UPDATE_FILE = 'createMaskitUpdateFile';
export const CREATE_ADP_UPDATE_FILE = 'createAdpUpdateFile';
export const UNDO_MARK_AS_UPDATE = 'undoMarkAsUpdate';
export const GENERATE_CUBE_DETAILS_REPORT = 'generateCubeDetailsReport';
export const GENERATE_MANAGERS_REPORT = 'exportManagersByCustomer';
export const GENERATE_COMPARE_RESULT_SEARCH_REPORT = 'generateCompareResultSearchReport';
export const GENERATE_GROUP_TYPE_EXPORT_EVENTS_REPORT = 'generateGroupTypeExportEventsReport';
export const GET_FORM_101_FILTERS_LIST = 'getForm101FiltersList';
export const GET_MANAGER_DOCUMENT_LIST = 'getFormDocumentsList';
export const GET_MANAGER_DOCUMENT_CONTENT = 'getDocumentContent';
export const GET_CUBES_FORM101_DATA = 'getCubesFormData';
export const GET_CUBES_FORM_101_CHANGES = 'getCubesForm101Changes';
export const GET_CUBES_STATS = 'getCubesStats';
export const MANUAL_UPDATE_IPT = 'manualUpdateIpt';

// Getters types
export const FORM101_OFFICES_LIST = 'form101OfficesList';
export const FORM101_UNITS_LIST = 'form101UnitsList';
export const FORM101_UNITS_LIST_LOADING = 'form101UnitsListLoading';
export const FORMS_SEARCH_OBJECT = 'formsSearchObject';
export const FORMS_SEARCH_FILTERS = 'formsSearchFilters';
export const FORMS_RESULT_DATA = 'formsResultData';
export const FORMS_SEARCH_ERRORS = 'formsSearchErrors';
export const STATISTICS = 'statistics';
export const STATISTICS_ERRORS = 'statisticsErrors';
export const STATISTICS_OFFICES = 'statisticsOffices';
export const MANAGER_MODE = 'managerMode';
export const MANAGER_LOADING = 'managerLoading';
export const FORM_STATUS_HISTORY = 'formStatusHistory';
export const FORM101_CHANGES = 'form101Changes';
export const FORM101_SECTION_NAMES = 'form101SectionNames';
export const FORM101_SECTION_NOTES = 'form101SectionNotes';
export const APPROVE_FORM_ERRORS = 'approveFormErrors';
export const REJECT_FORM_ERRORS = 'rejectFormErrors';
export const OPEN_REMOVE_FORM_MODAL = 'openRejectFormModal';
export const OPEN_REMOVE_FORM_MODAL_ERRORS = 'openRejectFormModalErrors';
export const FORM_101_CHANGES_NOTES_ERRORS = 'form101ChangesNotesErrors';
export const FORM_101_STATUSES_LIST = 'form101StatusesList';
export const SEARCH_EMPLOYEES_CURRENT_FORM = 'searchEmployeesCurrentForm';
export const OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL = 'openManagerFormResetPasswordModal';
export const OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL_ERRORS = 'openManagerFormResetPasswordModalErrors';
export const EMPLOYEE_EMAIL = 'employeeEmail';
export const CUBES_INFO = 'cubesInfo';
export const CUBES_INFO_ERRORS = 'cubesInfoErrors';
export const CUBE_DETAILS = 'cubeDetails';
export const CUBE_DETAILS_ERRORS = 'cubeDetailsErrors';
export const MASKIT_MODE = 'maskitMode';
export const ADP_MODE = 'adpMode';
export const OPEN_APPROVE_FORMS_MODAL = 'openApproveFormsModal';
export const OPEN_APPROVE_FORMS_MODAL_ERRORS = 'openApproveFormsModalErrors';
export const SELECTED_FORMS_TO_APPROVE = 'selectedFormsToApprove';
export const MANUAL_FORM = 'manualForm';
export const ID_NUMBER_FIELDS_DATA = 'idNumberFieldsData';
export const CAN_APPROVE = 'canApprove';
export const CAN_REJECT = 'canReject';
export const STATUS_DESC = 'statusDesc';
export const OPEN_MANUAL_FORM_MODAL = 'openManualFormModal';
export const FORM_101_REJECT_REASON = 'form101RejectReason';
export const FORM_101_FILTERS_LIST = 'form101FiltersList';
export const CUBE = 'cube';
export const CUBE_SEARCH_OBJECT = 'cubeSearchObject';
export const RESET_PASSWORD_LOADING = 'resetPasswordLoading';
export const CUBES_STATS = 'cubesStats';
export const CUBES_STATS_ERRORS = 'cubesStatsErrors';
export const CUBES_STATS_LOADING = 'cubesStatsLoading';
export const OPEN_MANUAL_UPDATE_IPT_MODAL = 'openManualUpdateIptModal';
export const MANUAL_UPDATE_IPT_MODAL_ERRORS = 'manualUpdateIptModalErrors';

// Mutations types
export const SET_FORM101_OFFICES_LIST = 'setForm101OfficesList';
export const SET_FORM101_UNITS_LIST = 'setForm101UnitsList';
export const SET_FORM101_UNITS_LOADING = 'setForm101UnitsListLoading';
export const SET_FORMS_SEARCH_OBJECT = 'setFormsSearchObject';
export const SET_FORMS_SEARCH_FILTERS = 'setFormsSearchFilters';
export const RESET_FORMS_SEARCH_OBJECT = 'resetFormsSearchObject';
export const RESET_EMPLOYEES_FORMS_SEARCH_OBJECT = 'resetEmployeesFormsSearchObject';
export const SET_FORMS_RESULT_DATA = 'setFormsResultData';
export const SET_FORMS_SEARCH_ERRORS = 'setFormsSearchErrors';
export const SET_STATISTICS = 'setStatistics';
export const SET_STATISTICS_ERRORS = 'setStatisticsErrors';
export const SET_STATISTICS_OFFICES = 'setStatisticsOffices';
export const SET_MANAGER_MODE = 'setManagerMode';
export const SET_MANAGER_LOADING = 'setManagerLoading';
export const SET_FORM_STATUS_HISTORY = 'setFormStatusHistory';
export const SET_FORM101_CHANGES = 'setForm101Changes';
export const SET_FORM101_SECTION_NAMES = 'form101SectionNames';
export const SET_APPROVE_FORM_ERRORS = 'setApproveFormErrors';
export const SET_REJECT_FORM_ERRORS = 'setRejectFormErrors';
export const SET_OPEN_REMOVE_FORM_MODAL = 'setOpenRemoveFormModal';
export const SET_OPEN_REMOVE_FORM_MODAL_ERRORS = 'setOpenRemoveFormModalErrors';
export const SET_FORM_101_CHANGES_NOTES_ERRORS = 'setForm101ChangesNotesErrors';
export const SET_FORM_101_STATUSES_LIST = 'setForm101StatusesList';
export const SET_SEARCH_EMPLOYEES_CURRENT_FORM = 'setSearchEmployeesCurrentForm';
export const SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL = 'setOpenManagerFormResetPasswordModal';
export const SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL_ERRORS = 'setOpenManagerFormResetPasswordModalErrors';
export const SET_EMPLOYEE_EMAIL = 'setEmployeeEmail';
export const SET_CUBES_INFO = 'setCubesInfo';
export const SET_CUBES_INFO_ERRORS = 'setCubesInfoErrors';
export const SET_CUBE_DETAILS = 'setCubeDetails';
export const SET_CUBE_DETAILS_ERRORS = 'setCubeDetailsErrors';
export const SET_MASKIT_MODE = 'setMaskitMode';
export const SET_ADP_MODE = 'setAdpMode';
export const SET_OPEN_APPROVE_FORMS_MODAL = 'setOpenApproveFormsModal';
export const SET_OPEN_APPROVE_FORMS_MODAL_ERRORS = 'setOpenApproveFormsModalErrors';
export const SET_SELECTED_FORMS_TO_APPROVE = 'setSelectedFormsToApprove';
export const ADD_MANUAL_FORM = 'addManualForm';
export const REMOVE_MANUAL_FORM = 'removeManualForm';
export const REMOVE_DIRTY_MANUAL_FORM = 'removeDirtyManualForm';
export const SET_ID_NUMBER_FIELDS_DATA = 'setIdNumberFieldsData';
export const MANAGER_RESET_STATE = 'managerResetState';
export const SET_CAN_APPROVE = 'setCanApprove';
export const SET_CAN_REJECT = 'setCanReject';
export const SET_STATUS_DESC = 'setStatusDesc';
export const SET_OPEN_MANUAL_FORM_MODAL = 'setOpenManualFormModal';
export const SET_FORM_101_REJECT_REASON = 'setForm101RejectReason';
export const SET_FORM_101_FILTERS_LIST = 'setForm101FiltersList';
export const SET_CUBE = 'setCube';
export const SET_CUBE_SEARCH_OBJECT = 'setCubeSearchObject';
export const SET_RESET_PASSWORD_LOADING = 'setResetPasswordLoading';
export const SET_CUBES_STATS = 'setCubesStats';
export const SET_CUBES_STATS_ERRORS = 'setCubesStatsErrors';
export const SET_CUBES_STATS_LOADING = 'setCubesStatsLoading';
export const SET_OPEN_MANUAL_UPDATE_IPT_MODAL = 'setOpenManualUpdateIptModal';
export const SET_MANUAL_UPDATE_IPT_MODAL_ERRORS = 'setManualUpdateIptModalErrors';
